export const PROGRESS_UPDATE = 'PROGRESS_UPDATE';
export const PROGRESS_CLEAR = 'PROGRESS_CLEAR';



// WEBPACK FOOTER //
// ./src/actions/progress.js